import {FC, memo} from 'react';
import {useLocation} from 'react-router-dom';

import {MenuList} from '@mui/material';

import SidebarLink from '../SidebarLink/SidebarLink';

import {IMenuItem} from '../../../../shared/types/menu.types';

import styles from './SidebarMenu.module.scss';

interface IMenu {
  menu: IMenuItem[];
}

const SidebarMenu: FC<IMenu> = memo(({menu}) => {
  const {pathname} = useLocation();

  return (
    <div className={styles.menu}>
      <MenuList>
        {menu.map((m, id) => (
          <SidebarLink item={m} selected={m.link === pathname} key={id} />
        ))}
      </MenuList>
    </div>
  );
});

export default SidebarMenu;
